import React, { Component } from 'react';
import { styled } from '@material-ui/core/styles';
import { Box, Button, Snackbar } from '@material-ui/core';
import { globalData, ADD, EDIT, VIEW, CLIENT, SPOUSE, NORMAL, CHILD } from '../../../../common/common';
import { egdeCollisions, deduplicationObjArr, newId, clone } from '../../../../common/utils';
import EstateMenu from '../EstateMenu';
import EstateContent from './EstateContent';
import Alert from '@material-ui/lab/Alert';
import EstatePList from './EstatePList';

const Root = styled(Box)({
    width: '1300px',
    '& .menuWapper': {
        width: '20%',
        minHeight: '650px',
        backgroundColor: '#FAFAFA',
    },
    '& .contentWapper': {
        width: '70%',
        height: '650px',
        padding: '24px',
        '& .cTop': {
            width: '100%',
            '& .pageTitle': {
                fontSize: '16px',
                fontWeight: 'bold',
                color: '#005E96',
            },
        },
        '& .cCenter': {
            width: '100%',
            overflowX: 'auto',
        },
        '& .cBottom': {
            width: '100%',
            '& .foot': {
                margin: '10px 0',
                '& .btn': {
                    width: '100px',
                    marginLeft: '10px',
                },
            },
        },
    },
    '& .listWapper': {
        width: '10%',
        height: '650px',
        backgroundColor: '#FAFAFA',
        overflowX: 'auto',
    },
    '& .line': {
        width: '100%',
        height: '1px',
        backgroundColor: '#A1A1A1',
        margin: '20px 0',
        opacity: '0.12',
    },
    '& .title': {
        fontSize: '18px',
        fontWeight: 'bold',
        color: '#212C31',
        marginTop: '18px',
    },
    '& .doc-type': {
        width: '200px',
        height: '26px',
        color: '#fff',
        fontSize: '12px',
        fontWeight: 'bold',
        borderRadius: '50px',
        backgroundColor: '#18C6FF'
    },
})

class EstateInfo extends Component {
    constructor(props) {
        super(props);
        this.state = {
            menuData: [
                "DOCUMENT INFO",
                "1. CLIENT’S GENERAL INFO",
                "2. CHILDREN",
                "3. EXECUTOR",
                "4. GUARDIAN",
                "5. GENERAL POWER OF ATTORNEY",
                "6. LIVING WILL",
                "7. TRUSTEE",
            ],
            contentData: {},
            menuIndex: 0,
            offsetL: 0,
            offsetT: 0,
            dragData: null,
            prevState: false,
            showToast: false,
            pListData: [],
        }
        this.handleCreate = this.handleCreate.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
        this.handleMenuIndex = this.handleMenuIndex.bind(this);
        this.handlePrev = this.handlePrev.bind(this);
        this.handleNext = this.handleNext.bind(this);
        this.handleClose = this.handleClose.bind(this);
        this.handleDown = this.handleDown.bind(this);
        this.handleMove = this.handleMove.bind(this);
        this.handleUp = this.handleUp.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.extractPList = this.extractPList.bind(this);
        this.updateInfoData = this.updateInfoData.bind(this);
    }
    render() {
        const {
            menuData,
            menuIndex,
            showToast,
            offsetL,
            offsetT,
            dragData,
            pListData,
        } = this.state;
        const { title, state, data } = this.props;
        const createBtn = () => {
            if (state === ADD && menuIndex === menuData.length - 1) {
                return <Button className="btn" variant="contained" color="primary" onClick={this.handleCreate}>create</Button>
            } else if (state === EDIT) {
                return <Button className="btn" variant="contained" color="primary" onClick={this.handleCreate}>save</Button>
            }
        }
        return (
            <Root id="estateInfo">
                <div className="h h-t">
                    <div className="menuWapper">
                        <EstateMenu
                            menuData={menuData}
                            menuIndex={menuIndex}
                            isLock={this.isLock()}
                            // isLock={false}
                            handleMenuIndex={this.handleMenuIndex}
                        />
                    </div>
                    <div className="contentWapper v">
                        <div className="cTop">
                            <div className="pageTitle h h-bt">
                                <div>{title}</div>
                                <div className="doc-type c">SINGLE WITH CHILDREN</div>
                            </div>
                            <div className="line"></div>
                        </div>
                        <div className="cCenter f">
                            <EstateContent
                                menuData={menuData}
                                contentData={data}
                                menuIndex={menuIndex}
                                state={state}
                                dragData={dragData}
                                handleChange={this.handleChange}
                                ref={(child) => { this.estateContent = child }}
                            />
                        </div>
                        <div className="cBottom">
                            <div className="line"></div>
                            <div className="foot h h-bt">
                                <div>
                                    <Button disabled={this.isNext("prev")} className="btn" variant="contained" color="primary" onClick={this.handlePrev}>PREVIOUS</Button>
                                    <Button disabled={this.isNext("next")} className="btn" variant="contained" color="primary" onClick={this.handleNext}>Next</Button>
                                </div>
                                <div>
                                    <Button className="btn" variant="contained" onClick={this.handleCancel}>CANCEL</Button>
                                    {createBtn()}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="listWapper v">
                        <EstatePList
                            data={data}
                            offsetL={offsetL}
                            offsetT={offsetT}
                            pList={pListData}
                            updateInfoData={this.updateInfoData}
                            handleDown={this.handleDown}
                            handleUp={this.handleUp}
                            handleMove={this.handleMove}
                        />
                    </div>
                </div>
                <Snackbar anchorOrigin={{ vertical: "top", horizontal: "center" }} open={showToast} autoHideDuration={3000} onClose={this.handleClose}>
                    <Alert severity="warning">
                        {globalData.toastMsg}
                    </Alert>
                </Snackbar>
            </Root>
        )
    }
    componentDidMount() {
        this.initGlobalData();
        const { state, data } = this.props;
        const estateDom = document.getElementById("estateInfo");
        const offsetL = estateDom.getBoundingClientRect().left;
        const offsetT = estateDom.getBoundingClientRect().top;
        let pListData = [];
        this.setState(() => ({
            offsetL,
            offsetT,
        }))
        if (state === ADD) {
            pListData = this.estateContent.getData();
        } else {
            pListData = data;
        }
        if (data) this.verifyClientsId(data, false);
        this.extractPList(pListData);
    }
    initGlobalData() {
        globalData.singleArr = [];
        globalData.dataINFO = {};
    }
    verifyClientsId(data, hasId = true) {
        const contentObj = data.content;
        if (!contentObj.hasOwnProperty("INFOS")) {
            const infos = this.extractInfoToArr(contentObj["INFO"]);
            contentObj["INFOS"] = infos;
        }
        const singleArr = this.extractSingleClient(contentObj, hasId);
        globalData.singleArr = singleArr;
        this.insertAttrToData(singleArr, contentObj);
    }
    extractInfoToArr(data) {
        let addrObjP = data["P.H.Addr"];
        addrObjP["phone"] = data["P.H.Pho"];
        let rcP = (data["P.SEX"] === "male") ? "Spouse's;Husband" : "Spouse's;Wife";
        let clientObj = clone(data);
        clientObj[".CHO.N."] = data["P.F.Name"];
        clientObj[".CHO.R.C."] = rcP;
        clientObj[".CHO.AddrNPho"] = addrObjP;
        clientObj["id"] = "1";
        clientObj["type"] = CLIENT;
        const arr = [clientObj];
        return arr;
    }
    extractSingleClient(contentObj, hasId) {
        let allClientArr = [];
        for (const key in contentObj) {
            const objArr = contentObj[key];
            if (objArr instanceof Array) {
                for (const obj of objArr) {
                    if (!obj.hasOwnProperty("type")) {
                        if (obj.hasOwnProperty("P.H.Name")) {
                            obj["id"] = "1";
                            obj["type"] = CLIENT;
                        } else if (obj.hasOwnProperty("RC")) {
                            obj["type"] = CHILD;
                        } else {
                            obj["type"] = NORMAL;
                        }
                    }
                    allClientArr.push(obj);
                }
            }
        }
        let singleArr = [];
        if (hasId) {
            singleArr = deduplicationObjArr(allClientArr, "id");
        } else {
            singleArr = deduplicationObjArr(allClientArr, ".CHO.N.");
            for (const obj of singleArr) {
                if (!obj.hasOwnProperty("id")) {
                    obj["id"] = newId();
                }
            }
        }
        console.log("singdArr", hasId, singleArr);
        return singleArr;
    }
    insertAttrToData(singleArr, contentObj) {
        for (const key in contentObj) {
            const objArr = contentObj[key];
            if (objArr instanceof Array) {
                for (const obj of objArr) {
                    for (const singleObj of singleArr) {
                        if (singleObj.hasOwnProperty(".CHO.N.") && obj.hasOwnProperty(".CHO.N.")) {
                            if (singleObj[".CHO.N."] === obj[".CHO.N."]) {
                                obj["id"] = singleObj["id"];
                                obj["type"] = singleObj["type"];
                            }
                        }
                    }
                }
            }
        }
        console.log("end obj：", contentObj)
    }
    handleMenuIndex(index) {
        this.setState(() => ({
            menuIndex: index
        }))
    }
    handleNext() {
        const { menuIndex } = this.state;
        const doNext = this.estateContent.doNext();
        if (doNext) {
            this.extractSpouseAndClient(menuIndex);
            const index = menuIndex + 1;
            this.setState(() => ({
                menuIndex: index
            }))
        } else {
            this.setState(() => ({
                showToast: true
            }))
        }
    }
    extractSpouseAndClient(menuIndex) {
        if (menuIndex === 1) {
            const data = this.estateContent.getData();
            const infoData = data.content["INFO"];
            const clientInfo = {};

            clientInfo["id"] = infoData["id"];
            clientInfo[".CHO.Em"] = infoData["P.Em"];
            clientInfo[".CHO.N."] = infoData["P.F.Name"];
            clientInfo[".CHO.AddrNPho"] = infoData["P.H.Addr"];
            clientInfo[".CHO.Addr"] = infoData["P.H.Addr"];
            clientInfo["P.H.Pho"] = infoData["P.H.Pho"];
            clientInfo["P.W.Pho"] = infoData["P.W.Pho"];
            clientInfo[".CHO.R.C."] = (infoData["P.SEX"] === "male") ? "Spouse's;Husband" : "Spouse's;Wife";
            clientInfo["rc"] = "Spouse's";
            clientInfo["relation"] = (infoData["P.SEX"] === "male") ? "Husband" : "Wife";
            globalData.clientInfo = clientInfo;
        }
    }
    handlePrev() {
        const { menuIndex } = this.state;
        const index = menuIndex - 1;
        this.setState(() => ({
            menuIndex: index
        }))
    }
    handleCreate() {
        const doNext = this.estateContent.doNext();
        if (doNext) {
            let obj = this.estateContent.getData();
            this.props.handleCreate(obj);
        } else {
            this.setState(() => ({
                showToast: true
            }))
        }
    }
    handleCancel() {
        this.props.handleCancel();
    }
    handleClose() {
        this.setState(() => ({
            showToast: false
        }))
        globalData.toastMsg = "Please fill in the complete information";
    }
    handleDown() {
        this.setState({
            dragData: globalData.dragData
        }, () => {
            this.estateContent.handleDown();
        })
    }
    handleUp() {
        if (globalData.isCollision) {
            this.setState(() => ({
                dragData: globalData.dragData
            }))
        } else {
            this.setState(() => ({
                dragData: null
            }))
        }
        this.estateContent.handleUp();
    }
    handleMove(obj) {
        const { offsetL, offsetT, prevState } = this.state;
        let rect1 = obj;
        let rect2 = this.estateContent ? this.estateContent.getContentRectData() : null;
        if (!rect1 || !rect2) return;
        rect2.left -= offsetL;
        rect2.top -= offsetT;
        const isCollision = egdeCollisions(rect1, rect2);
        if (prevState !== isCollision) {
            globalData.isCollision = isCollision;
            this.setState(() => ({
                prevState: isCollision
            }));
            if (isCollision) {
                this.estateContent.handleCollision();
            } else {
                this.estateContent.handleLeave();
            }
        }
    }
    handleChange(name, value) {
        const data = this.estateContent.getData();
        this.extractPList(data, name, value);
        this.verifyClientsId(data);
    }
    extractPList(data, name, value) {
        if (!data) return [];
        const contentObj = data.content;
        if (contentObj["INFO"]) globalData.dataINFO = contentObj["INFO"];
        let pList = [];
        for (const key in contentObj) {
            const objArr = contentObj[key];
            if (objArr instanceof Array) {
                for (const obj of objArr) {
                    if (obj.hasOwnProperty(".CHO.N.")) {
                        if (obj[".CHO.N."].trim()) {
                            if (!obj.hasOwnProperty(".CHO.Em")) obj[".CHO.Em"] = "";
                            pList.push(obj);
                        }
                    }
                    if (obj.hasOwnProperty("Name")) {
                        if (obj["Name"].trim()) {
                            obj[".CHO.N."] = obj["Name"];
                            obj[".CHO.AddrNPho"] = obj["AddrNPho"];
                            obj["rc"] = obj["rc"] ? obj["rc"] : "Client's";
                            obj["relation"] = obj["relation"] !== "" ? obj["relation"] : obj["RC"];
                            obj[".CHO.R.C."] = obj["rc"] + ";" + obj["RC"];
                            pList.push(obj);
                        }
                    }
                }
            }
        }
        const emailArr = this.extractEmailArr(pList);
        const newEmailArr = deduplicationObjArr(emailArr, ".CHO.N.");
        let pListData = deduplicationObjArr(pList, ".CHO.N.");
        let arr = [];
        if (value) {
            arr = value;
        } else if (value !== null) {
            arr = newEmailArr;
        }
        if (arr.length > 0) {
            for (const obj1 of pListData) {
                for (const obj2 of arr) {
                    if (obj1.hasOwnProperty(".CHO.Em") && obj2.hasOwnProperty(".CHO.Em")) {
                        if (obj1[".CHO.N."] === obj2[".CHO.N."]) {
                            obj1[".CHO.Em"] = obj2[".CHO.Em"];
                        }
                    }
                }
            }
        }
        this.setState(() => ({
            pListData
        }))
    }
    extractEmailArr(data) {
        let arr = [];
        for (const obj of data) {
            if (obj.hasOwnProperty(".CHO.Em")) {
                if (obj[".CHO.Em"] !== "") {
                    arr.push(obj);
                }
            }
        }
        return arr;
    }
    updateInfoData(panelData) {
        const type = panelData.type;
        if (type === CHILD || type === NORMAL) {
            this.estateContent.uploadChildNormalToAllData(panelData);
        } else {
            this.setDataInfo(panelData, (dataINFO) => {
                this.estateContent.setToAllData("INFO", dataINFO, () => {
                    this.estateContent.updateInfoToAllData();
                });
            });
        }
    }
    setDataInfo(panelData, callback = null) {
        const dataINFO = globalData.dataINFO;
        console.log("globalData.dataINFO",dataINFO)
        for (const key in panelData) {
            if (Object.hasOwnProperty.call(panelData, key)) {
                for (const key2 in dataINFO) {
                    if (Object.hasOwnProperty.call(dataINFO, key2)) {
                        if (key === key2) {
                            dataINFO[key2] = panelData[key];
                        }
                    }
                }
            }
        }
        if (callback) callback(dataINFO);
    }
    rmSpouse(contentObj) {
        for (const key in contentObj) {
            if (contentObj.hasOwnProperty(key)) {
                const element = contentObj[key];
                if (this.rmSpouseKey(key)) {
                    element.shift();
                }
            }
        }
    }
    rmSpouseKey(key) {
        if (key === "Ex") {//3
            return false;
        } else if (key === "Gu") {//4
            return true;
        } else if (key === "POA") {//5
            return false;
        } else if (key === "C.W.S.P.R") {//8
            return false;
        } else if (key === "C.F.S.P.R") {//9
            return false;
        } else if (key === "S.Ex") {//11
            return false;
        } else if (key === "S.Gu") {//12
            return true;
        } else if (key === "S.POA") {//13
            return false;
        } else if (key === "S.W.S.P.R") {//16
            return false;
        } else if (key === "S.F.S.P.R") {//17
            return false;
        } else if (key === "TRUSTEE") {//19
            return false;
        } else {
            return false;
        }
    }
    isNext(type) {
        const {
            menuData,
            menuIndex,
        } = this.state;
        if (type === "next") {
            return (menuIndex >= menuData.length - 1);
        } else if (type === "prev") {
            return (menuIndex <= 0);
        }
    }
    isLock() {
        const { state } = this.props;
        return state === ADD;
    }
    isDisabled() {
        const { state } = this.props;
        if (state === ADD) {
            return false;
        } else if (state === VIEW) {
            return true;
        } else if (state === EDIT) {
            return false;
        }
    }
}

export default EstateInfo;